export function model(definition) {
    return Object.freeze(definition);
}
//# sourceMappingURL=model-definitions.js.map